export function validateUrl(value: string, required: boolean = true): string | undefined {
    if (required && (!value || value.trim() === '')) {
        return 'This field is required.';
    }
    if (value) {
        try {
            new URL(value);
        } catch {
            return 'Please enter a valid URL.';
        }
    }
    return undefined;
}